import { useState, useCallback, lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Loader from './components/loader/Loader';
import Hero from './components/hero/Hero';
import TargetSection from './components/target/TargetSection';
import PainSection from './components/pain/PainSection';
import ServicesGrid from './components/services/ServicesGrid';
import Projects from './components/projects/Projects';
import Quote from './components/quote/Quote';
import AboutLilach from './components/about/AboutLilach';
import Testimonials from './components/testimonials/Testimonials';
import WorkProcess from './components/process/WorkProcess';
import FaqChat from './components/faq/FaqChat';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
const PrivacyPage = lazy(() => import('./components/privacy/PrivacyPage'));

function HomePage() {
  const [loading, setLoading] = useState(true);
  const handleLoaded = useCallback(() => setLoading(false), []);

  return (
    <>
      {loading && <Loader onComplete={handleLoaded} />}
      <Navbar />
      <Hero />
      <TargetSection />
      <PainSection />
      <AboutLilach />
      <Testimonials />
      <ServicesGrid />
      <Projects />
      <WorkProcess />
      <Quote />
      <FaqChat />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<Suspense fallback={<div />}><PrivacyPage /></Suspense>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
